import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const NoOfPallets = ({ pallets }: SpecProps<"pallets">) => {
  const { i18n } = useLingui();

  if (!pallets) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.truck.pallets",
    message: "Number of pallets",
    comment: "Field for 'Number of pallets for truck' in ad specification",
  });

  return <FieldValuePair field={field} value={pallets} />;
};
